import { usersPortfolioTranslations } from '@sh4res/bo-common/i18n/en/users/portfolio';

export const usersTranslations = {
  portfolio: usersPortfolioTranslations,
  actions: {
    remove_block: {
      title: 'Confirmation',
      confirm: 'Are you sure you want to lift the email block?',
      confirm_note:
        'NOTE: if email fails to be sent or gets reported as spam again, it will be permanently blocked.',
      success: 'Block successfully removed',
      failure: 'Block failed to be removed: \n%{error}',
    },
    unremovable_block: {
      title: 'This email address cannot be unblocked',
      reason: {
        permanently_blocked:
          'Its block was already lifted once, and emails to it then bounced or were reported as spam again. The block is now permanent.',
        invalid:
          'Our email provider flagged this address as undeliverable, for example because of a typo or a mailbox that does not exist.',
      },
      resolution:
        'To fix this, ask the person for a different email address, then edit the record and replace this address with the new one. Emails will be sent to the new address from then on.',
    },
  },
};
